import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TreeNavigation, TreeNavigationItem, TreeNavigationDropdown } from '../../common';
import AWSAccountRequest from '../../../models/entities/AWSAccountRequest';

interface AWSAccountsHomeActionsRowProps {
	awsAccount: AWSAccountRequest;
}

const AWSAccountHomeActionsRow = ({ awsAccount }: AWSAccountsHomeActionsRowProps) => {
	const navigate = useNavigate();

	return (
		<TreeNavigation>
			{awsAccount?.canSeePortOpeningRequests() && (
				<TreeNavigationDropdown textColor="primary" label="Port Opening Requests">
					{awsAccount.canSubmitPortOpeningRequests() && (
						// TODO: Should redirect the form to request AWS PORs from the account Id to={`/awsAccounts/${awsAccount?.id}/awsPortOpeningRequest/new`
						<TreeNavigationItem
							textColor="primary"
							label="Create a Request"
							onClick={() => navigate(`/awsAccounts/awsPortOpeningRequest/new`)}
						/>
					)}
					{/* TODO: Should redirect to a table with the history of AWS PORs from the account Id to={`/awsAccounts/${awsAccount?.id}/PortOpeningRequestsHistory` */}
					<TreeNavigationItem
						textColor="primary"
						label="Request History"
						onClick={() => navigate(`/awsAccounts/${awsAccount?.id}/connectedAWS`)}
					/>
				</TreeNavigationDropdown>
			)}
		</TreeNavigation>
	);
};

export default AWSAccountHomeActionsRow;
